module.exports = __webpack_public_path__ + "img/16_86.57110003.png";